module.exports = __webpack_public_path__ + "media/images/good_smiley-b9cf76f560f680e69228f01b83c6e132.svg";